export const CourierPickupAlert = () => {
  return (
    <div
      className="tab-pane fade"
      id="pills-courier"
      role="tabpanel"
      aria-labelledby="pills-courier-tab"
    >
      <div className="courier-pickup-msg">
        <h4>Important!</h4>
        <p>
          Courier Pickup service needs to be arranged by you. Please enter into
          the comments box located on the payment screen the courier company you
          will be organising to pick up your parcel and any other related
          details.
        </p>
      </div>
    </div>
  );
};
